import { ChangeDetectionStrategy, Component } from '@angular/core';
import { LoaderService } from '@services/loader.service';
import { delay } from 'rxjs';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
  isLoading = this.loaderService.isLoading.pipe(delay(0));
  constructor(private readonly loaderService: LoaderService) {}
}
